import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatViews, statusLabel } from "@/utils/comic";
import Icon from "@/components/base/Icon";

interface ComicCardProps {
  comic: Comic;
  showDesc?: boolean;
}

export default function ComicCard({ comic, showDesc = false }: ComicCardProps) {
  const ongoing = comic.status === "ongoing";
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - 作者：${comic.author}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded-full text-[11px] font-medium ${
            ongoing
              ? "bg-primary-500 text-background-50"
              : "bg-secondary-500 text-background-50"
          }`}
        >
          {statusLabel(comic.status)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-background-50/90 text-accent-700 flex items-center gap-0.5">
          <Icon name="ri-star-fill" className="w-3 h-3 text-accent-500" />
          {comic.rating}
        </span>
      </div>
      <div className="flex flex-col p-3 flex-1">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
        {showDesc && (
          <p className="mt-2 text-xs text-foreground-600 line-clamp-2">
            {comic.description}
          </p>
        )}
        <div className="mt-auto pt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <Icon name="ri-eye-line" className="w-3.5 h-3.5" />
            {formatViews(comic.views)}
          </span>
          <span className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-600">
            {comic.region}
          </span>
        </div>
      </div>
    </Link>
  );
}